import React from 'react';
import PropTypes from 'prop-types';
import styles from './DashboardConfiguration.module.css';

const DashboardConfiguration = ({ title, onClose, children }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h2>{title}</h2>
                    <button className={styles.exitButton} onClick={onClose} aria-label="Close configuration modal">X</button>
                </div>
                <div className={styles.modalContent}>{children}</div>
            </div>
        </div>
    );
};

DashboardConfiguration.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default DashboardConfiguration;